import withEditarPasswordSesion from "../../hoc/withTrabajadores/withEditarPasswordSesion";
import EditarPassword from "../../view/components/RegistroUsuarios/DatosSesion/EditarDatosSesion/EditarPassword";

export default withEditarPasswordSesion(EditarPassword);